import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import PlayerHeader from './PlayerHeader';
import PlayerInfo from './PlayerInfo';
import Bio from './Bio';
import './index.css';

class PersonDetail01 extends Component {
  state = {
      items: this.props.data && this.props.data.contentData[0].gist,
      selection: true
    }

  selection = (e) => {
    if (_.endsWith(e.target.className, 'selected')) {
      return;
    }

    this.setState({
      selection: !this.state.selection
    })
  }

  componentDidMount = () => {
    const id = this.state.items.integrationId
    if (id === null) {
      return this.setState({ selection: false })
    }
    axios.get(`/player/stats/${id}`)
     .then((res) => {
      this.setState({ 
        api: res
      });
    }).catch((err) => {
      console.log(err);
    })
  }

  render() {
    const items = this.state.items;
    const selected = this.state.selection;

    return (
      <div className='person-detail-01'>   
        <PlayerHeader data={items} />
        <div className='page-selection'>
          <div onClick={this.selection} className={selected? 
          'player-stats site-border-color selected' : 'player-stats'}>Stats</div>
          <div onClick={this.selection} className={selected? 'player-bio' : 
          'player-bio site-border-color selected'}>Bio</div>
        </div>
        { selected ? 
          <PlayerInfo 
            api={this.state.api} 
            data={this.props.data} 
          /> :
          <Bio 
            text={items.body} 
            data={this.props.data}
          /> 
        }       
      </div>
    )
  }
}

export default PersonDetail01;
